const T = {
  "nav.overview": { fr: "Vue d'ensemble", en: "Overview" },
  "nav.banks": { fr: "Mes banques", en: "My Banks" },
  "nav.subscriptions": { fr: "Abonnements", en: "Subscriptions" },
  "nav.domains": { fr: "Domaines", en: "Domains" },
  "nav.wallet": { fr: "Recharger mon compte", en: "Top Up My Account" },

  "dashboard.availableBalance": { fr: "Solde disponible", en: "Available Balance" },
  "dashboard.topUpAccount": { fr: "Recharger mon compte", en: "Top Up Account" },
  "dashboard.buySubscription": { fr: "Acheter un abonnement", en: "Buy Plan" },
  "dashboard.newSubscription": { fr: "Un nouvel abonnement = une nouvelle banque à créer.", en: "One new plan = one new bank to create." },
  "dashboard.createBank": { fr: "Créer une banque", en: "Create a Bank" },
  "dashboard.chooseTemplate": { fr: "Choisis un template, personnalise et lance ta marque.", en: "Choose a template, personalize and launch your brand." },
  "dashboard.welcome": { fr: "Bienvenue", en: "Welcome" },
  "dashboard.title": { fr: "Tableau de bord", en: "Dashboard" },
  "dashboard.subtitle": { fr: "Pilote tes banques en ligne.", en: "Manage your banks online." },
  "dashboard.myBanks": { fr: "Mes banques", en: "My Banks" },
  "dashboard.activeSubscriptions": { fr: "Abonnements actifs", en: "Active Plans" },
  "dashboard.pendingSubscriptions": { fr: "En attente de validation", en: "Pending Validation" },
  "dashboard.bankUsers": { fr: "Utilisateurs finaux", en: "End Users" },
  "dashboard.cardsIssued": { fr: "Cartes émises", en: "Cards Issued" },
  "dashboard.transactions": { fr: "Transactions", en: "Transactions" },

  "banks.title": { fr: "Mes banques", en: "My Banks" },
  "banks.viewDemo": { fr: "Voir la démo", en: "View Demo" },
  "banks.newBank": { fr: "Nouvelle banque", en: "New Bank" },
  "banks.demoTitle": { fr: "Choisir un template à démontrer", en: "Choose a Template to Demo" },
  "banks.demoSubtitle": { fr: "Sélectionnez un template pour voir exactement ce que vos futurs clients verront. Toutes les interfaces sont accessibles en mode démo — aucune action réelle n'est effectuée.", en: "Select a template to see exactly what your future customers will see. All interfaces are in demo mode — no real actions performed." },
  "banks.openDemo": { fr: "Ouvrir la démo", en: "Open Demo" },
  "banks.noBanksCreated": { fr: "Aucune banque créée", en: "No Banks Created" },
  "banks.launchFirstBank": { fr: "Lance ta première banque en quelques minutes.", en: "Launch your first bank in minutes." },

  "newbank.title": { fr: "Créer une banque", en: "Create a Bank" },
  "newbank.subtitle": { fr: "Sélectionne un abonnement actif disponible et personnalise ta marque.", en: "Select an active plan and personalize your brand." },
  "newbank.noActiveSubs": { fr: "Aucun abonnement actif disponible", en: "No Active Plans Available" },
  "newbank.noActiveSubsHint": { fr: "Achète un abonnement pour créer ta banque.", en: "Buy a plan to create your bank." },
  "newbank.viewSubs": { fr: "Voir mes abonnements", en: "View My Plans" },
  "newbank.subscription": { fr: "Abonnement à utiliser", en: "Plan to Use" },
  "newbank.selectSub": { fr: "Choisir un abonnement actif…", en: "Choose an active plan…" },
  "newbank.name": { fr: "Nom de la banque", en: "Bank Name" },
  "newbank.primaryColor": { fr: "Couleur principale", en: "Primary Color" },
  "newbank.logo": { fr: "URL du logo (optionnel)", en: "Logo URL (optional)" },
  "newbank.tagline": { fr: "Slogan", en: "Tagline" },
  "newbank.currency": { fr: "Devise", en: "Currency" },
  "newbank.defaultLang": { fr: "Langue par défaut", en: "Default Language" },
  "newbank.chooseTemplate": { fr: "Choisir un template", en: "Choose a Template" },
  "newbank.create": { fr: "Créer la banque", en: "Create Bank" },
  "newbank.created": { fr: "Banque créée !", en: "Bank Created!" },
  "newbank.recreationFeeTitle": { fr: "Frais de recréation :", en: "Recreation fee:" },
  "newbank.recreationFeePrefix": { fr: "Cet abonnement a déjà hébergé une banque. La recréation d'une banque sur ce même abonnement entraîne des frais de", en: "This plan previously hosted a bank. Recreating a bank on the same plan will charge" },
  "newbank.recreationFeeSuffix": { fr: "prélevés de votre portefeuille.", en: "from your wallet." },

  "managebank.label": { fr: "Banque", en: "Bank" },
  "managebank.publicPreview": { fr: "Aperçu public", en: "Public Preview" },
  "managebank.copyLink": { fr: "Copier le lien", en: "Copy Link" },
  "managebank.delete": { fr: "Supprimer", en: "Delete" },
  "managebank.copyLocalizedLink": { fr: "Copier le lien localisé", en: "Copy Localized Link" },
  "managebank.linkDesc": { fr: "Choisissez la langue parlée par votre client. Le lien ouvrira le site directement dans cette langue.", en: "Choose your customer's language. The link opens the site in that language." },
  "managebank.clientLang": { fr: "Langue du client", en: "Client Language" },
  "managebank.linkCopied": { fr: "Lien copié !", en: "Link Copied!" },
  "managebank.copy": { fr: "Copier", en: "Copy" },
  "managebank.loading": { fr: "Chargement…", en: "Loading…" },
  "managebank.tabUsers": { fr: "Utilisateurs", en: "Users" },
  "managebank.tabOps": { fr: "Opérations", en: "Operations" },
  "managebank.tabTxns": { fr: "Historique", en: "History" },
  "managebank.tabTransfers": { fr: "Virements", en: "Transfers" },
  "managebank.tabMessages": { fr: "Messages", en: "Messages" },
  "managebank.tabCredits": { fr: "Crédits", en: "Credits" },
  "managebank.tabInvestments": { fr: "Investissements", en: "Investments" },
  "managebank.tabFinancings": { fr: "Financements", en: "Financings" },
  "managebank.tabCards": { fr: "Cartes", en: "Cards" },
  "managebank.tabNotifications": { fr: "Notifications", en: "Notifications" },
  "managebank.tabDeposit": { fr: "Dépôt", en: "Deposit" },
  "managebank.tabLanding": { fr: "Page d'accueil", en: "Landing" },
  "managebank.tabBranding": { fr: "Branding", en: "Branding" },
  "managebank.deleteTitle": { fr: "Supprimer la banque", en: "Delete Bank" },
  "managebank.deleteMsg": { fr: "Supprimer cette banque et toutes ses données ? Cette action est irréversible. Aucun frais ne sera prélevé.", en: "Delete this bank and all its data? This action is irreversible. No fee will be charged." },
  "managebank.deleted": { fr: "Banque supprimée", en: "Bank Deleted" },

  "users.title": { fr: "Utilisateurs finaux", en: "End Users" },
  "users.signupLink": { fr: "Lien d'inscription", en: "Signup Link" },
  "users.createManually": { fr: "Créer manuellement", en: "Create Manually" },
  "users.newUser": { fr: "Nouvel utilisateur", en: "New User" },
  "users.fullName": { fr: "Nom complet *", en: "Full Name *" },
  "users.email": { fr: "Email *", en: "Email *" },
  "users.password": { fr: "Mot de passe *", en: "Password *" },
  "users.phone": { fr: "Téléphone", en: "Phone" },
  "users.country": { fr: "Pays", en: "Country" },
  "users.address": { fr: "Adresse", en: "Address" },
  "users.createAccount": { fr: "Créer le compte", en: "Create Account" },
  "users.added": { fr: "Utilisateur ajouté", en: "User Added" },
  "users.publicSignupLink": { fr: "Lien d'inscription public", en: "Public Signup Link" },
  "users.signupLinkHint": { fr: "Envoie ce lien à ton client. Il pourra créer lui-même son compte.", en: "Send this link to your client. They can create their own account." },
  "users.copied": { fr: "Copié", en: "Copied" },
  "users.copy": { fr: "Copier", en: "Copy" },
  "users.settingsTitle": { fr: "Paramètres de", en: "Settings for" },
  "users.displayCurrency": { fr: "Devise d'affichage", en: "Display Currency" },
  "users.displayLang": { fr: "Langue d'affichage", en: "Display Language" },
  "users.iban": { fr: "IBAN (personnalisé)", en: "IBAN (custom)" },
  "users.bic": { fr: "BIC / SWIFT", en: "BIC / SWIFT" },
  "users.ibanConfirmed": { fr: "IBAN confirmé (révèle les 4 derniers chiffres)", en: "IBAN Confirmed (reveals last 4 digits)" },
  "users.ibanHint": { fr: "Laisser vide pour conserver l'IBAN généré automatiquement.", en: "Leave empty to keep the auto-generated IBAN." },
  "users.stopTitle": { fr: "Barre de progression du virement — ", en: "Transfer Progress Bar — " },
  "users.stopHint": { fr: "Quand cet utilisateur valide un virement, la barre s'arrêtera à ce pourcentage. 0 = pas de blocage. 100 = virement complété normalement.", en: "When this user validates a transfer, the bar stops at this percentage. 0 = no block. 100 = completes normally." },
  "users.stopPct": { fr: "Pourcentage d'arrêt (%)", en: "Stop Percentage (%)" },
  "users.stopMsg": { fr: "Message affiché au client lors du blocage", en: "Message Shown to Client on Block" },
  "users.kycTitle": { fr: "Documents KYC — ", en: "KYC Documents — " },
  "users.idType": { fr: "Type de pièce :", en: "ID Type:" },
  "users.idCard": { fr: "Carte d'identité", en: "ID Card" },
  "users.passport": { fr: "Passeport", en: "Passport" },
  "users.driverLicense": { fr: "Permis de conduire", en: "Driver's License" },
  "users.idFront": { fr: "Recto pièce d'identité", en: "ID Front" },
  "users.idBack": { fr: "Verso pièce d'identité", en: "ID Back" },
  "users.selfie": { fr: "Selfie avec pièce", en: "Selfie with ID" },
  "users.addressProof": { fr: "Justificatif de domicile", en: "Address Proof" },
  "users.notProvided": { fr: "Non fourni", en: "Not Provided" },
  "users.openPdf": { fr: "Ouvrir le PDF", en: "Open PDF" },
  "users.openFile": { fr: "Ouvrir le fichier", en: "Open File" },
  "users.validateAccount": { fr: "Valider le compte", en: "Validate Account" },
  "users.loginHistTitle": { fr: "Historique de connexions — ", en: "Login History — " },
  "users.noLoginHist": { fr: "Aucune connexion enregistrée.", en: "No Login Recorded." },
  "users.nameEmail": { fr: "Nom / Email", en: "Name / Email" },
  "users.balance": { fr: "Solde", en: "Balance" },
  "users.status": { fr: "Statut", en: "Status" },
  "users.pending": { fr: "En attente", en: "Pending" },
  "users.blocked": { fr: "Bloqué", en: "Blocked" },
  "users.block": { fr: "Bloquer", en: "Block" },
  "users.unblock": { fr: "Débloquer", en: "Unblock" },
  "users.validate": { fr: "Valider", en: "Validate" },
  "users.validated": { fr: "Utilisateur validé et activé", en: "User Validated and Activated" },
  "users.unblocked": { fr: "Débloqué", en: "Unblocked" },
  "users.connections": { fr: "Connexions", en: "Connections" },
  "users.settings": { fr: "Paramètres", en: "Settings" },
  "users.progression": { fr: "Progression", en: "Progression" },
  "users.noUsers": { fr: "Aucun utilisateur.", en: "No Users." },
  "users.settingsUpdated": { fr: "Paramètres mis à jour", en: "Settings Updated" },
  "users.stopSaved": { fr: "Barre de progression enregistrée", en: "Progress Bar Saved" },

  "cards.title": { fr: "Cartes virtuelles", en: "Virtual Cards" },
  "cards.user": { fr: "Utilisateur", en: "User" },
  "cards.holderName": { fr: "Nom sur la carte", en: "Cardholder Name" },
  "cards.network": { fr: "Réseau", en: "Network" },
  "cards.issue": { fr: "Émettre", en: "Issue" },
  "cards.issued": { fr: "Carte émise", en: "Card Issued" },
  "cards.holder": { fr: "Titulaire", en: "Holder" },
  "cards.expiry": { fr: "Exp.", en: "Exp." },
  "cards.client": { fr: "Client :", en: "Client:" },
  "cards.blocked": { fr: "Bloquée", en: "Blocked" },
  "cards.edit": { fr: "Modifier", en: "Edit" },
  "cards.delete": { fr: "Supprimer", en: "Delete" },
  "cards.noCards": { fr: "Aucune carte.", en: "No Cards." },
  "cards.physicalOrders": { fr: "Commandes de cartes physiques", en: "Physical Card Orders" },
  "cards.trackingNo": { fr: "N° suivi", en: "Tracking No." },
  "cards.physicalType": { fr: "Type physique", en: "Physical Type" },
  "cards.tracking": { fr: "Suivi", en: "Tracking" },
  "cards.inPreparation": { fr: "En préparation", en: "In Preparation" },
  "cards.shipped": { fr: "Expédié", en: "Shipped" },
  "cards.inTransit": { fr: "En transit", en: "In Transit" },
  "cards.delivered": { fr: "Livré", en: "Delivered" },
  "cards.messages": { fr: "Messages", en: "Messages" },
  "cards.closeMessages": { fr: "Fermer", en: "Close" },
  "cards.customMessages": { fr: "Messages personnalisés par étape", en: "Custom Messages per Step" },
  "cards.msgPlaceholder": { fr: "Message personnalisé pour cette étape…", en: "Custom message for this step…" },
  "cards.saveMessages": { fr: "Enregistrer les messages", en: "Save Messages" },
  "cards.saving": { fr: "Enregistrement…", en: "Saving…" },
  "cards.cancel": { fr: "Annuler", en: "Cancel" },
  "cards.physicalCards": { fr: "Cartes physiques", en: "Physical Cards" },
  "cards.physicalCardsDesc": { fr: "Configurez le nom, prix et avantages de chaque type de carte physique.", en: "Configure the name, price and benefits of each physical card type." },
  "cards.resetDefault": { fr: "Réinitialiser aux valeurs par défaut", en: "Reset to Defaults" },
  "cards.price": { fr: "Prix", en: "Price" },
  "cards.displayName": { fr: "Nom affiché", en: "Display Name" },
  "cards.benefits": { fr: "Avantages (un par ligne)", en: "Benefits (one per line)" },
  "cards.resetTitle": { fr: "Réinitialiser les cartes physiques", en: "Reset Physical Cards" },
  "cards.resetMsg": { fr: "Remplacer la configuration actuelle par les 3 types par défaut (Metal 29€, Premium 49€, Gold 99€) ? Tes personnalisations seront perdues.", en: "Replace with 3 default types (Metal 29€, Premium 49€, Gold 99€)? Your customizations will be lost." },
  "cards.deleteTitle": { fr: "Supprimer la carte", en: "Delete Card" },
  "cards.deleteMsg": { fr: "Supprimer définitivement la carte", en: "Permanently delete the card" },
  "cards.deletePhysicalTitle": { fr: "Supprimer la commande physique", en: "Delete Physical Order" },
  "cards.deletePhysicalMsg": { fr: "Supprimer la commande physique", en: "Delete physical order" },
  "cards.confirmed": { fr: "Carte confirmée (révèle les 4 derniers chiffres)", en: "Card Confirmed (reveals last 4 digits)" },
  "cards.fullNumber": { fr: "Numéro complet", en: "Full Number" },
  "cards.cvv": { fr: "CVV", en: "CVV" },
  "cards.expiration": { fr: "Expiration", en: "Expiration" },
  "cards.spendingLimits": { fr: "Plafonds de dépense", en: "Spending Limits" },
  "cards.daily": { fr: "Journalier (€)", en: "Daily (€)" },
  "cards.weekly": { fr: "Hebdomadaire (€)", en: "Weekly (€)" },
  "cards.monthly": { fr: "Mensuel (€)", en: "Monthly (€)" },
  "cards.deleted": { fr: "Carte supprimée", en: "Card Deleted" },
  "cards.physicalDeleted": { fr: "Commande physique supprimée — la carte virtuelle est conservée", en: "Physical order deleted — virtual card preserved" },
  "cards.typeUpdated": { fr: "Type de carte mis à jour", en: "Card Type Updated" },
  "cards.reset": { fr: "Types de cartes réinitialisés", en: "Card Types Reset" },

  "ops.title": { fr: "Opérations bancaires", en: "Banking Operations" },
  "ops.user": { fr: "Utilisateur", en: "User" },
  "ops.operation": { fr: "Opération", en: "Operation" },
  "ops.recharge": { fr: "Recharger (+)", en: "Recharge (+)" },
  "ops.refund": { fr: "Remboursement (+)", en: "Refund (+)" },
  "ops.transferIn": { fr: "Virement entrant (+)", en: "Incoming Transfer (+)" },
  "ops.withdraw": { fr: "Retrait (-)", en: "Withdrawal (-)" },
  "ops.transferOut": { fr: "Virement sortant (-)", en: "Outgoing Transfer (-)" },
  "ops.amount": { fr: "Montant", en: "Amount" },
  "ops.label": { fr: "Libellé (optionnel)", en: "Label (optional)" },
  "ops.validate": { fr: "Valider l'opération", en: "Validate Operation" },
  "ops.recorded": { fr: "Opération enregistrée", en: "Operation Recorded" },
  "ops.resetUser": { fr: "Réinitialiser uniquement l'historique et le solde de", en: "Reset only history and balance of" },
  "ops.resetUserBtn": { fr: "Réinitialiser", en: "Reset" },
  "ops.resetAll": { fr: "Réinitialiser tout l'historique", en: "Reset All History" },
  "ops.resetAllMsg": { fr: "Réinitialiser l'historique de tous les utilisateurs — remet tous les soldes à zéro.", en: "Reset history of all users — resets all balances to zero." },
  "ops.resetAllConfirm": { fr: "Réinitialiser tout l'historique des transactions et les soldes de TOUS les utilisateurs ? Cette action est irréversible.", en: "Reset all transaction history and balances of ALL users? This action is irreversible." },
  "ops.historyReset": { fr: "Historique réinitialisé", en: "History Reset" },

  "notifs.title": { fr: "Notifications dashboard client", en: "Client Dashboard Notifications" },
  "notifs.recipient": { fr: "Destinataire", en: "Recipient" },
  "notifs.allUsers": { fr: "Tous les utilisateurs (broadcast)", en: "All Users (broadcast)" },
  "notifs.notifTitle": { fr: "Titre", en: "Title" },
  "notifs.message": { fr: "Message", en: "Message" },
  "notifs.send": { fr: "Envoyer", en: "Send" },
  "notifs.sent": { fr: "Notification envoyée", en: "Notification Sent" },
  "notifs.private": { fr: "Privée", en: "Private" },
  "notifs.broadcast": { fr: "Broadcast", en: "Broadcast" },
  "notifs.none": { fr: "Aucune notification.", en: "No Notifications." },

  "transfers.title": { fr: "Virements clients", en: "Client Transfers" },
  "transfers.viewCode": { fr: "Voir le code", en: "View Code" },
  "transfers.sendCode": { fr: "Envoyer le code", en: "Send Code" },
  "transfers.reject": { fr: "Rejeter", en: "Reject" },
  "transfers.codeSent": { fr: "Code envoyé au client (expire dans 5 min)", en: "Code sent to client (expires in 5 min)" },
  "transfers.rejected": { fr: "Virement rejeté", en: "Transfer Rejected" },
  "transfers.none": { fr: "Aucun virement en attente.", en: "No Pending Transfers." },

  "msgs.search": { fr: "Rechercher une conversation…", en: "Search Conversations…" },
  "msgs.newConv": { fr: "Nouvelle conversation", en: "New Conversation" },
  "msgs.searchClient": { fr: "Rechercher un client…", en: "Search Client…" },
  "msgs.allHaveConv": { fr: "Tous les clients ont déjà une conversation.", en: "All clients already have a conversation." },
  "msgs.noConversations": { fr: "Aucune conversation pour l'instant.", en: "No Conversations Yet." },
  "msgs.noResults": { fr: "Aucun résultat.", en: "No Results." },
  "msgs.selectConv": { fr: "Sélectionnez une conversation pour commencer", en: "Select a Conversation to Start" },
  "msgs.loading": { fr: "Chargement…", en: "Loading…" },
  "msgs.clearHistory": { fr: "Effacer l'historique de cette conversation", en: "Delete This Conversation's History" },
  "msgs.clearTitle": { fr: "Effacer l'historique", en: "Delete History" },
  "msgs.noMessages": { fr: "Aucun message dans cette conversation.", en: "No Messages in This Conversation." },
  "msgs.remove": { fr: "Retirer", en: "Remove" },
  "msgs.attachImage": { fr: "Image", en: "Image" },
  "msgs.attachPdf": { fr: "PDF", en: "PDF" },
  "msgs.attachAudio": { fr: "Audio", en: "Audio" },
  "msgs.attachFile": { fr: "Fichier / Document", en: "File / Document" },
  "msgs.attach": { fr: "Joindre un fichier", en: "Attach File" },
  "msgs.placeholder": { fr: "Écrire un message…", en: "Write a Message…" },
  "msgs.send": { fr: "Envoyer", en: "Send" },
  "msgs.fileTooLarge": { fr: "Fichier trop volumineux", en: "File Too Large" },
  "msgs.cleared": { fr: "Historique effacé", en: "History Deleted" },

  "credits.catalog": { fr: "Offres de crédit", en: "Credit Offers" },
  "credits.requests": { fr: "Demandes des clients", en: "Client Requests" },
  "credits.newOffer": { fr: "Nouvelle offre", en: "New Offer" },
  "credits.desc": { fr: "Personnalisez les offres de crédit affichées aux clients.", en: "Customize credit offers shown to customers." },
  "credits.amount": { fr: "Montant :", en: "Amount:" },
  "credits.rate": { fr: "Taux :", en: "Rate:" },
  "credits.duration": { fr: "Durée :", en: "Duration:" },
  "credits.deposit": { fr: "Dépôt :", en: "Deposit:" },
  "credits.guarantee": { fr: "Garantie :", en: "Guarantee:" },
  "credits.none": { fr: "Aucune offre de crédit.", en: "No Credit Offers." },
  "credits.newTitle": { fr: "Nouvelle offre de crédit", en: "New Credit Offer" },
  "credits.editTitle": { fr: "Modifier l'offre", en: "Edit Offer" },
  "credits.name": { fr: "Nom du crédit", en: "Credit Name" },
  "credits.description": { fr: "Description", en: "Description" },
  "credits.minAmount": { fr: "Montant min (€)", en: "Min Amount (€)" },
  "credits.maxAmount": { fr: "Montant max (€)", en: "Max Amount (€)" },
  "credits.minRate": { fr: "Taux min (%)", en: "Min Rate (%)" },
  "credits.maxRate": { fr: "Taux max (%)", en: "Max Rate (%)" },
  "credits.minDuration": { fr: "Durée min (mois)", en: "Min Duration (months)" },
  "credits.maxDuration": { fr: "Durée max (mois)", en: "Max Duration (months)" },
  "credits.initialDeposit": { fr: "Dépôt initial (€)", en: "Initial Deposit (€)" },
  "credits.guarantee": { fr: "Garantie demandée", en: "Required Guarantee" },
  "credits.conditions": { fr: "Conditions d'éligibilité", en: "Eligibility Conditions" },
  "credits.color": { fr: "Couleur", en: "Color" },
  "credits.visible": { fr: "Visible par les clients", en: "Visible to Customers" },
  "credits.hidden": { fr: "Masqué", en: "Hidden" },
  "credits.saved": { fr: "Offre enregistrée", en: "Offer Saved" },
  "credits.deleted": { fr: "Offre supprimée", en: "Offer Deleted" },
  "credits.deleteTitle": { fr: "Supprimer l'offre", en: "Delete Offer" },
  "credits.deleteMsg": { fr: "Supprimer définitivement l'offre", en: "Permanently delete the offer" },
  "credits.requestsDuration": { fr: "mois", en: "months" },
  "credits.requestsDeposit": { fr: "dépôt", en: "deposit" },
  "credits.view": { fr: "Voir", en: "View" },
  "credits.approve": { fr: "Approuver", en: "Approve" },
  "credits.reject": { fr: "Rejeter", en: "Reject" },
  "credits.approved": { fr: "Approuvé — dépôt initial prélevé", en: "Approved — initial deposit deducted" },
  "credits.requestRejected": { fr: "Demande rejetée", en: "Request Rejected" },
  "credits.modalTitle": { fr: "Modalités du crédit", en: "Credit Terms" },
  "credits.client": { fr: "Client", en: "Client" },
  "credits.product": { fr: "Produit", en: "Product" },
  "credits.requestedOn": { fr: "Demandé le", en: "Requested on" },
  "credits.editCreditTitle": { fr: "Modifier le crédit", en: "Edit Credit" },
  "credits.amountEur": { fr: "Montant (€)", en: "Amount (€)" },
  "credits.durationMonths": { fr: "Durée (mois)", en: "Duration (months)" },
  "credits.depositEur": { fr: "Dépôt initial (€)", en: "Initial Deposit (€)" },
  "credits.ratePercent": { fr: "Taux (%)", en: "Rate (%)" },
  "credits.statusNote": { fr: "Le changement de statut ici ne prélève pas le dépôt. Utilisez « Approuver » pour prélever le dépôt initial.", en: "Changing status here doesn't deduct the deposit. Use 'Approve' to deduct it." },
  "credits.accepted": { fr: "Accepté", en: "Accepted" },
  "credits.refused": { fr: "Refusé", en: "Refused" },
  "credits.clearTitle": { fr: "Supprimer l'historique des crédits", en: "Delete Credit History" },
  "credits.clearMsg": { fr: "Supprimer définitivement toutes les demandes de crédit de cette banque ? Cette action est irréversible.", en: "Permanently delete all credit requests for this bank? This action is irreversible." },
  "credits.cleared": { fr: "Historique des crédits supprimé", en: "Credit History Deleted" },
  "credits.noneRequests": { fr: "Aucune demande de crédit.", en: "No Credit Requests." },

  "investments.catalog": { fr: "Offres d'investissement", en: "Investment Offers" },
  "investments.requests": { fr: "Demandes des clients", en: "Client Requests" },
  "investments.newOffer": { fr: "Nouvelle offre", en: "New Offer" },
  "investments.desc": { fr: "Le rendement personnalisé par client se configure dans l'onglet « Demandes des clients ».", en: "Per-client yield is configured in the 'Client Requests' tab." },
  "investments.none": { fr: "Aucune offre d'investissement.", en: "No Investment Offers." },
  "investments.newTitle": { fr: "Nouvelle offre d'investissement", en: "New Investment Offer" },
  "investments.editTitle": { fr: "Modifier l'offre", en: "Edit Offer" },
  "investments.name": { fr: "Nom", en: "Name" },
  "investments.description": { fr: "Description", en: "Description" },
  "investments.color": { fr: "Couleur", en: "Color" },
  "investments.visible": { fr: "Visible par les clients", en: "Visible to Customers" },
  "investments.saved": { fr: "Offre enregistrée", en: "Offer Saved" },
  "investments.deleted": { fr: "Offre supprimée", en: "Offer Deleted" },
  "investments.deleteTitle": { fr: "Supprimer l'offre", en: "Delete Offer" },
  "investments.deleteMsg": { fr: "Supprimer définitivement l'offre", en: "Permanently delete the offer" },
  "investments.dailyYield": { fr: "%/jour", en: "%/day" },
  "investments.profit": { fr: "profit", en: "profit" },
  "investments.yield": { fr: "Rendement", en: "Yield" },
  "investments.approve": { fr: "Approuver", en: "Approve" },
  "investments.reject": { fr: "Rejeter", en: "Reject" },
  "investments.approved": { fr: "Investissement validé — montant prélevé", en: "Investment Approved — amount deducted" },
  "investments.requestRejected": { fr: "Demande rejetée", en: "Request Rejected" },
  "investments.modalTitle": { fr: "Modalités de l'investissement", en: "Investment Terms" },
  "investments.client": { fr: "Client", en: "Client" },
  "investments.product": { fr: "Produit", en: "Product" },
  "investments.amount": { fr: "Montant", en: "Amount" },
  "investments.profitLabel": { fr: "Profit", en: "Profit" },
  "investments.note": { fr: "Note", en: "Note" },
  "investments.yieldPerDay": { fr: "Rendement / jour", en: "Yield / Day" },
  "investments.start": { fr: "Début", en: "Start" },
  "investments.end": { fr: "Fin", en: "End" },
  "investments.requestedOn": { fr: "Demandé le", en: "Requested on" },
  "investments.approveNote": { fr: "En approuvant, le montant est prélevé du solde du client.", en: "Approving deducts the amount from the client's balance." },
  "investments.yieldTitle": { fr: "Rendement personnalisé — ", en: "Custom Yield — " },
  "investments.yieldDesc": { fr: "Définissez un gain journalier pour cet investissement.", en: "Set a daily gain for this investment." },
  "investments.dailyGain": { fr: "Gain journalier (%)", en: "Daily Gain (%)" },
  "investments.amountEur": { fr: "Montant investi (€)", en: "Invested Amount (€)" },
  "investments.startDate": { fr: "Date de début", en: "Start Date" },
  "investments.endDate": { fr: "Date de fin", en: "End Date" },
  "investments.estimate": { fr: "Estimation :", en: "Estimate:" },
  "investments.profitPerDay": { fr: "de profit par jour.", en: "profit per day." },
  "investments.saveYield": { fr: "Enregistrer le rendement", en: "Save Yield" },
  "investments.validated": { fr: "Validé", en: "Validated" },
  "investments.refused": { fr: "Refusé", en: "Refused" },
  "investments.clearTitle": { fr: "Supprimer l'historique des investissements", en: "Delete Investment History" },
  "investments.clearMsg": { fr: "Supprimer définitivement toutes les demandes d'investissement de cette banque ? Cette action est irréversible.", en: "Permanently delete all investment requests for this bank? This action is irreversible." },
  "investments.cleared": { fr: "Historique des investissements supprimé", en: "Investment History Deleted" },
  "investments.yieldConfigured": { fr: "Rendement configuré", en: "Yield Configured" },
  "investments.noneRequests": { fr: "Aucune demande d'investissement.", en: "No Investment Requests." },
  "investments.view": { fr: "Voir", en: "View" },

  "financings.catalog": { fr: "Offres de financement", en: "Financing Offers" },
  "financings.requests": { fr: "Demandes des clients", en: "Client Requests" },
  "financings.newOffer": { fr: "Nouvelle offre", en: "New Offer" },
  "financings.none": { fr: "Aucune offre de financement.", en: "No Financing Offers." },
  "financings.newTitle": { fr: "Nouvelle offre de financement", en: "New Financing Offer" },
  "financings.editTitle": { fr: "Modifier l'offre", en: "Edit Offer" },
  "financings.name": { fr: "Nom", en: "Name" },
  "financings.description": { fr: "Description", en: "Description" },
  "financings.type": { fr: "Type", en: "Type" },
  "financings.repayable": { fr: "Remboursable", en: "Repayable" },
  "financings.nonRepayable": { fr: "Non remboursable", en: "Non-Repayable" },
  "financings.color": { fr: "Couleur", en: "Color" },
  "financings.visible": { fr: "Visible par les clients", en: "Visible to Customers" },
  "financings.hidden": { fr: "Masqué", en: "Hidden" },
  "financings.saved": { fr: "Offre enregistrée", en: "Offer Saved" },
  "financings.deleted": { fr: "Offre supprimée", en: "Offer Deleted" },
  "financings.deleteTitle": { fr: "Supprimer l'offre", en: "Delete Offer" },
  "financings.deleteMsg": { fr: "Supprimer définitivement l'offre", en: "Permanently delete the offer" },
  "financings.repayableLabel": { fr: "Remboursable", en: "Repayable" },
  "financings.nonRepayableLabel": { fr: "Non remboursable", en: "Non-Repayable" },
  "financings.sector": { fr: "secteur", en: "sector" },
  "financings.view": { fr: "Voir", en: "View" },
  "financings.approve": { fr: "Approuver", en: "Approve" },
  "financings.reject": { fr: "Rejeter", en: "Reject" },
  "financings.approved": { fr: "Financement accordé — fonds crédités", en: "Financing Granted — funds credited" },
  "financings.requestRejected": { fr: "Demande rejetée", en: "Request Rejected" },
  "financings.modalTitle": { fr: "Modalités du financement", en: "Financing Terms" },
  "financings.client": { fr: "Client", en: "Client" },
  "financings.project": { fr: "Projet", en: "Project" },
  "financings.sectorLabel": { fr: "Secteur", en: "Sector" },
  "financings.amountLabel": { fr: "Montant", en: "Amount" },
  "financings.descriptionLabel": { fr: "Description", en: "Description" },
  "financings.status": { fr: "Statut", en: "Status" },
  "financings.requestedOn": { fr: "Demandé le", en: "Requested on" },
  "financings.approveNote": { fr: "En approuvant, le montant est crédité sur le solde du client.", en: "Approving credits the amount to the client's balance." },
  "financings.granted": { fr: "Accordé", en: "Granted" },
  "financings.refused": { fr: "Refusé", en: "Refused" },
  "financings.clearTitle": { fr: "Supprimer l'historique des financements", en: "Delete Financing History" },
  "financings.clearMsg": { fr: "Supprimer définitivement toutes les demandes de financement de cette banque ? Cette action est irréversible.", en: "Permanently delete all financing requests for this bank? This action is irreversible." },
  "financings.cleared": { fr: "Historique des financements supprimé", en: "Financing History Deleted" },
  "financings.noneRequests": { fr: "Aucune demande de financement.", en: "No Financing Requests." },

  "landing.title": { fr: "Personnalisation de la page d'accueil", en: "Landing Page Customization" },
  "landing.pathNote": { fr: "Cette page sera affichée sur", en: "This page will be displayed at" },
  "landing.heroSection": { fr: "Section Hero", en: "Hero Section" },
  "landing.mainTitle": { fr: "Titre principal", en: "Main Title" },
  "landing.subtitle": { fr: "Sous-titre", en: "Subtitle" },
  "landing.ctaText": { fr: "Texte du bouton CTA", en: "CTA Button Text" },
  "landing.features": { fr: "3 blocs de fonctionnalités", en: "3 Feature Blocks" },
  "landing.contact": { fr: "Coordonnées (footer)", en: "Contact (footer)" },
  "landing.email": { fr: "Email de contact", en: "Contact Email" },
  "landing.phone": { fr: "Téléphone", en: "Phone" },
  "landing.address": { fr: "Adresse", en: "Address" },
  "landing.social": { fr: "Réseaux sociaux (footer)", en: "Social Networks (footer)" },
  "landing.options": { fr: "Options", en: "Options" },
  "landing.signupsOpen": { fr: "Inscriptions ouvertes", en: "Signups Open" },
  "landing.signupsOpenDesc": { fr: "Si désactivé, le bouton d'inscription est masqué.", en: "If disabled, signup button is hidden." },
  "landing.transferValidation": { fr: "Code de validation pour les virements sortants", en: "Validation Code for Outgoing Transfers" },
  "landing.transferValidationDesc": { fr: "L'admin doit transmettre un code 6 chiffres au client avant que le virement parte.", en: "Admin must send a 6-digit code to client before transfer goes through." },
  "landing.save": { fr: "Enregistrer", en: "Save" },
  "landing.translate": { fr: "Traduire le contenu automatiquement", en: "Auto-Translate Content" },
  "landing.translating": { fr: "Traduction en cours…", en: "Translating…" },
  "landing.translated": { fr: "Contenu traduit en 10 langues avec succès", en: "Content translated to 10 languages successfully" },
  "landing.translationNote": { fr: "La traduction automatique génère des versions en anglais, espagnol, portugais, allemand, italien, néerlandais, russe, turc, polonais et roumain.", en: "Auto-translation generates versions in English, Spanish, Portuguese, German, Italian, Dutch, Russian, Turkish, Polish, and Romanian." },
  "landing.saved": { fr: "Landing enregistré", en: "Landing Saved" },

  "deposit.title": { fr: "Modalités de dépôt", en: "Deposit Terms" },
  "deposit.instructions": { fr: "Instructions de dépôt", en: "Deposit Instructions" },
  "deposit.hint": { fr: "Laissez vide pour afficher le message par défaut.", en: "Leave empty to display the default message." },
  "deposit.save": { fr: "Enregistrer", en: "Save" },
  "deposit.updated": { fr: "Instructions de dépôt mises à jour", en: "Deposit Instructions Updated" },

  "branding.name": { fr: "Nom", en: "Name" },
  "branding.color": { fr: "Couleur", en: "Color" },
  "branding.tagline": { fr: "Slogan", en: "Tagline" },
  "branding.logo": { fr: "Logo", en: "Logo" },
  "branding.chooseFile": { fr: "Choisir un fichier", en: "Choose File" },
  "branding.upload": { fr: "Uploader le logo", en: "Upload Logo" },
  "branding.uploading": { fr: "Upload...", en: "Upload..." },
  "branding.directUrl": { fr: "ou URL directe", en: "or Direct URL" },
  "branding.template": { fr: "Template", en: "Template" },
  "branding.defaultCurrency": { fr: "Devise par défaut de la banque", en: "Bank Default Currency" },
  "branding.defaultLang": { fr: "Langue par défaut de la banque", en: "Bank Default Language" },
  "branding.save": { fr: "Enregistrer", en: "Save" },
  "branding.updated": { fr: "Branding mis à jour", en: "Branding Updated" },
  "branding.logoUpdated": { fr: "Logo mis à jour", en: "Logo Updated" },

  "subs.title": { fr: "Mes packs", en: "My Plans" },
  "subs.subtitle": { fr: "Un pack = une banque. Paiement unique, accès à vie.", en: "One plan = one bank. One-time payment, lifetime access." },
  "subs.buy": { fr: "Acheter un pack", en: "Buy Plan" },
  "subs.buyTitle": { fr: "Acheter un pack", en: "Buy Plan" },
  "subs.plan": { fr: "Pack", en: "Plan" },
  "subs.selectPlan": { fr: "Choisir…", en: "Choose…" },
  "subs.users": { fr: "users", en: "users" },
  "subs.validate": { fr: "Valider", en: "Validate" },
  "subs.activated": { fr: "Pack activé — Coins déduits de votre portefeuille.", en: "Plan Activated — Coins Deducted from Wallet." },
  "subs.active": { fr: "active", en: "active" },
  "subs.pending": { fr: "pending", en: "pending" },
  "subs.upgraded": { fr: "upgraded", en: "upgraded" },
  "subs.bankCreated": { fr: "Banque créée", en: "Bank Created" },
  "subs.available": { fr: "Disponible", en: "Available" },
  "subs.extraUsers": { fr: "utilisateurs supplémentaires", en: "extra users" },
  "subs.addUsers": { fr: "+ Utilisateurs", en: "+ Users" },
  "subs.upgradeTo": { fr: "Passer à", en: "Upgrade to" },
  "subs.createBank": { fr: "Créer la banque", en: "Create Bank" },
  "subs.none": { fr: "Aucun pack. Achète ton premier pack pour démarrer.", en: "No Plans. Buy your first plan to start." },
  "subs.extraUsersTitle": { fr: "Utilisateurs supplémentaires", en: "Extra Users" },
  "subs.howMany": { fr: "Combien d'utilisateurs ?", en: "How Many Users?" },
  "subs.perUser": { fr: "/user — déduit de votre portefeuille", en: "/user — deducted from wallet" },
  "subs.upgradeTitle": { fr: "Passer au forfait supérieur", en: "Upgrade Plan" },
  "subs.upgradeMsg": { fr: "Passer au forfait", en: "Upgrade to" },
  "subs.usersAdded": { fr: "utilisateur(s) ajouté(s) — ", en: "user(s) added — " },
  "subs.deducted": { fr: "déduits", en: "deducted" },
  "subs.upgradeActivated": { fr: "Upgrade activé — Coins déduits de votre portefeuille", en: "Upgrade Activated — Coins Deducted from Wallet" },
  "subs.maxUsers": { fr: "utilisateurs max", en: "max users" },

  "domains.title": { fr: "Domaines", en: "Domains" },
  "domains.searchBuy": { fr: "Rechercher & acheter", en: "Search & Buy" },
  "domains.search": { fr: "Rechercher", en: "Search" },
  "domains.available": { fr: "Disponible", en: "Available" },
  "domains.unavailable": { fr: "Indisponible", en: "Unavailable" },
  "domains.buy": { fr: "Acheter", en: "Buy" },
  "domains.orders": { fr: "Mes commandes", en: "My Orders" },
  "domains.purchase": { fr: "Achat", en: "Purchase" },
  "domains.dns": { fr: "Connexion DNS", en: "DNS Connection" },
  "domains.ordered": { fr: "en attente d'activation", en: "pending activation" },
  "domains.none": { fr: "Aucune commande.", en: "No Orders." },
  "domains.purchased": { fr: "Domaine commandé — en attente d'activation", en: "Domain Ordered — pending activation" },

  "wallet.title": { fr: "Recharger mon compte", en: "Top Up My Account" },
  "wallet.subtitle": { fr: "Gérez votre solde en Coins pour les services de la plateforme.", en: "Manage your Coin balance for platform services." },
  "wallet.availableBalance": { fr: "Solde disponible", en: "Available Balance" },
  "wallet.topup": { fr: "Recharger", en: "Top Up" },
  "wallet.history": { fr: "Historique des transactions", en: "Transaction History" },
  "wallet.none": { fr: "Aucune transaction pour le moment.", en: "No Transactions Yet." },
  "wallet.topupTitle": { fr: "Recharger le portefeuille", en: "Top Up Wallet" },
  "wallet.topupSubtitle": { fr: "Saisissez le montant en Coins à créditer sur votre compte.", en: "Enter the amount in Coins to credit to your account." },
  "wallet.amount": { fr: "Montant (Coins)", en: "Amount (Coins)" },
  "wallet.validate": { fr: "Valider", en: "Validate" },
  "wallet.added": { fr: "ajoutés à votre compte", en: "added to your account" },

  "txns.title": { fr: "Historique des opérations", en: "Operations History" },
  "txns.user": { fr: "Utilisateur", en: "User" },
  "txns.label": { fr: "Libellé", en: "Label" },
  "txns.type": { fr: "Type", en: "Type" },
  "txns.amount": { fr: "Montant", en: "Amount" },
  "txns.balance": { fr: "Solde", en: "Balance" },
  "txns.date": { fr: "Date", en: "Date" },
  "txns.none": { fr: "Aucune transaction.", en: "No Transactions." },

  "nav.referral": { fr: "Parrainage", en: "Referral" },
  "nav.support": { fr: "Support", en: "Support" },

  "referral.title": { fr: "Programme de parrainage", en: "Referral Program" },
  "referral.subtitle": { fr: "Gagnez 5 % de commission sur chaque abonnement acheté par vos filleuls.", en: "Earn 5% commission on every plan purchased by your referrals." },
  "referral.yourLink": { fr: "Votre lien de parrainage", en: "Your Referral Link" },
  "referral.copy": { fr: "Copier", en: "Copy" },
  "referral.referees": { fr: "Filleuls", en: "Referrals" },
  "referral.validated": { fr: "Validées", en: "Validated" },
  "referral.pending": { fr: "En attente", en: "Pending" },
  "referral.refereesTitle": { fr: "Filleuls", en: "Referrals" },
  "referral.name": { fr: "Nom", en: "Name" },
  "referral.email": { fr: "Email", en: "Email" },
  "referral.signedUp": { fr: "Inscrit le", en: "Signed up on" },
  "referral.commissions": { fr: "Historique des commissions", en: "Commission History" },
  "referral.noCommissions": { fr: "Aucune commission pour l'instant — partagez votre lien pour commencer !", en: "No commissions yet — share your link to get started!" },
  "referral.referee": { fr: "Filleul", en: "Referral" },
  "referral.planBought": { fr: "Pack acheté", en: "Plan Purchased" },
  "referral.commission": { fr: "Commission", en: "Commission" },
  "referral.status": { fr: "Statut", en: "Status" },
  "referral.date": { fr: "Date", en: "Date" },
  "referral.statusValidated": { fr: "Validée", en: "Validated" },
  "referral.statusPending": { fr: "En attente", en: "Pending" },
  "referral.available": { fr: "Disponible au retrait", en: "Available for withdrawal" },
  "referral.withdraw": { fr: "Demander un retrait", en: "Request withdrawal" },
  "referral.transferBalance": { fr: "Transférer vers mon solde", en: "Transfer to my balance" },
  "referral.transferConfirm": { fr: "Transférer tous les gains disponibles vers votre solde de plateforme ?", en: "Transfer all available earnings to your platform balance?" },
  "referral.transferred": { fr: "Gains transférés vers le solde !", en: "Earnings transferred to balance!" },
  "referral.withdrawHistory": { fr: "Historique des retraits", en: "Withdrawal history" },
  "referral.noWithdrawals": { fr: "Aucune demande de retrait pour l'instant.", en: "No withdrawal requests yet." },
  "referral.method": { fr: "Méthode", en: "Method" },
  "referral.method.mobile_money": { fr: "Mobile Money", en: "Mobile Money" },
  "referral.method.wave": { fr: "Wave", en: "Wave" },
  "referral.method.crypto_usdt": { fr: "Crypto USDT", en: "Crypto USDT" },
  "referral.method.transfer_to_balance": { fr: "Transfert solde", en: "Balance transfer" },
  "referral.phone": { fr: "Numéro Mobile Money / Wave", en: "Mobile Money / Wave number" },
  "referral.network": { fr: "Réseau crypto", en: "Crypto network" },
  "referral.address": { fr: "Adresse de portefeuille", en: "Wallet address" },
  "referral.amount": { fr: "Montant (Coins)", en: "Amount (Coins)" },
  "referral.statusApproved": { fr: "Payé", en: "Paid" },
  "referral.statusRejected": { fr: "Rejeté", en: "Rejected" },
  "referral.statusTransferred": { fr: "Transféré", en: "Transferred" },
  "referral.destination": { fr: "Destination", en: "Destination" },
  "referral.sa.title": { fr: "Retraits de parrainage", en: "Referral Withdrawals" },
  "referral.sa.subtitle": { fr: "Demandes de retrait des gains de parrainage en attente de paiement.", en: "Referral earning withdrawal requests pending payment." },
  "referral.sa.approve": { fr: "Approuver", en: "Approve" },
  "referral.sa.reject": { fr: "Rejeter", en: "Reject" },
  "referral.sa.all": { fr: "Tous", en: "All" },
  "referral.sa.empty": { fr: "Aucune demande de retrait.", en: "No withdrawal requests." },

  "support.title": { fr: "Contacter le support", en: "Contact Support" },
  "support.subtitle": { fr: "Écrivez directement à notre équipe pour toute question ou problème.", en: "Write directly to our team for any question or issue." },
  "support.loading": { fr: "Chargement…", en: "Loading…" },
  "support.empty": { fr: "Aucun message pour l'instant. Écrivez votre premier message ci-dessous.", en: "No messages yet. Write your first message below." },
  "support.you": { fr: "Vous", en: "You" },
  "support.supportLabel": { fr: "Support", en: "Support" },
  "support.placeholder": { fr: "Décrivez votre problème ou votre question…", en: "Describe your problem or question…" },
  "support.send": { fr: "Envoyer", en: "Send" },
  "support.sending": { fr: "Envoi…", en: "Sending…" },
  "support.sent": { fr: "Message envoyé au support", en: "Message sent to support" },

  "pwreset.button": { fr: "Historique mots de passe", en: "Password History" },
  "pwreset.title": { fr: "Réinitialiser le mot de passe", en: "Reset Password" },
  "pwreset.confirm": { fr: "Générer un nouveau mot de passe sécurisé pour", en: "Generate a new secure password for" },
  "pwreset.confirmEnd": { fr: "? Le mot de passe actuel sera immédiatement remplacé.", en: "? The current password will be immediately replaced." },
  "pwreset.generate": { fr: "Générer (afficher uniquement)", en: "Generate (display only)" },
  "pwreset.generateEmail": { fr: "Générer et envoyer par email", en: "Generate and send by email" },
  "pwreset.generated": { fr: "Nouveau mot de passe généré", en: "New password generated" },
  "pwreset.generatedEmail": { fr: "Nouveau mot de passe généré et envoyé par email", en: "New password generated and sent by email" },
  "pwreset.newPassword": { fr: "Nouveau mot de passe", en: "New Password" },
  "pwreset.hint": { fr: "Communiquez ce mot de passe à votre client. Il devra le changer après sa première connexion.", en: "Share this password with your customer. They should change it after first login." },
  "pwreset.close": { fr: "Fermer", en: "Close" },
  "pwreset.copied": { fr: "Mot de passe copié", en: "Password copied" },
  "pwreset.toastEmail": { fr: "Mot de passe généré et envoyé par email", en: "Password generated and sent by email" },
  "pwreset.toastGen": { fr: "Nouveau mot de passe généré", en: "New password generated" },
  "pwreset.histTitle": { fr: "Historique des réinitialisations", en: "Reset History" },
  "pwreset.deleteAll": { fr: "Tout supprimer", en: "Delete All" },
  "pwreset.histEmpty": { fr: "Aucune réinitialisation enregistrée.", en: "No resets recorded." },
  "pwreset.sentByEmail": { fr: "envoyé par email", en: "sent by email" },
  "pwreset.copyTitle": { fr: "Copier", en: "Copy" },
  "pwreset.deleteTitle": { fr: "Supprimer", en: "Delete" },
  "pwreset.delEntryTitle": { fr: "Supprimer cette entrée", en: "Delete this entry" },
  "pwreset.delEntryMsg": { fr: "Supprimer cette entrée de l'historique des réinitialisations ?", en: "Delete this entry from the reset history?" },
  "pwreset.delAllTitle": { fr: "Tout supprimer", en: "Delete All" },
  "pwreset.delAllMsg": { fr: "Supprimer tout l'historique des réinitialisations de mot de passe pour cette banque ? Cette action est irréversible.", en: "Delete all password reset history for this bank? This action is irreversible." },
  "pwreset.entryDeleted": { fr: "Entrée supprimée", en: "Entry deleted" },
  "pwreset.deletedCount": { fr: "entrée(s) supprimée(s)", en: "entry/entries deleted" },
  "pwreset.delete": { fr: "Supprimer", en: "Delete" },
  "pwreset.cancel": { fr: "Annuler", en: "Cancel" },

  "maintenance.label": { fr: "Maintenance", en: "Maintenance" },
  "maintenance.daysLeft": { fr: "j restants", en: "days left" },
  "maintenance.today": { fr: "aujourd'hui", en: "today" },
  "maintenance.overdue": { fr: "⚠ Maintenance en retard — banque suspendue", en: "⚠ Maintenance overdue — bank suspended" },
  "maintenance.dueIn": { fr: "⚠ Maintenance due dans", en: "⚠ Maintenance due in" },
  "maintenance.days": { fr: "jour(s)", en: "day(s)" },
  "maintenance.pay1month": { fr: "Payer 1 mois", en: "Pay 1 month" },
  "maintenance.pay1year": { fr: "Payer 1 an", en: "Pay 1 year" },
  "maintenance.monthlyPaid": { fr: "Maintenance mensuelle payée !", en: "Monthly maintenance paid!" },
  "maintenance.annualPaid": { fr: "Maintenance annuelle payée !", en: "Annual maintenance paid!" },

  "common.cancel": { fr: "Annuler", en: "Cancel" },
  "common.confirm": { fr: "Confirmer", en: "Confirm" },
  "common.save": { fr: "Enregistrer", en: "Save" },
  "common.loading": { fr: "Chargement…", en: "Loading…" },
  "common.close": { fr: "Fermer", en: "Close" },
  "common.edit": { fr: "Modifier", en: "Edit" },
  "common.delete": { fr: "Supprimer", en: "Delete" },
  "common.yes": { fr: "Oui", en: "Yes" },
  "common.no": { fr: "Non", en: "No" },

  "shell.openMenu": { fr: "Ouvrir le menu", en: "Open Menu" },
  "shell.closeMenu": { fr: "Fermer le menu", en: "Close Menu" },
  "shell.navigation": { fr: "Navigation", en: "Navigation" },
  "shell.logout": { fr: "Déconnexion", en: "Logout" },
  "shell.superAdmin": { fr: "Super Admin", en: "Super Admin" },
  "shell.admin": { fr: "Admin", en: "Admin" },
  "shell.adminSpace": { fr: "Espace Admin", en: "Admin Space" },
  "shell.superAdminSpace": { fr: "Super Admin", en: "Super Admin" },
};

export function adminT(lang, key) {
  const entry = T[key];
  if (!entry) return key;
  return entry[lang] ?? entry.fr ?? key;
}

export default T;
